import type { FaireProductEntity } from "../../entity_types/product";

export const p_yfnpdjd5t6: FaireProductEntity = {
  token: "p_yfnpdjd5t6",
  type: "product",
  name: "FRINGE HEM PONCHO TOP",
  brandToken: "b_22tswwgnqb",
  brandName: "Emory Park",
  imageUrl: "https://cdn.faire.com/fastly/2d80f48a9067893c3a226720de054930a7055c268567e7ac4dc36ba44438c289.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/877f45c486a17c5f1dbe14263b29dd7777ce4149f04a8c477182ef6e531aa042.jpeg",
    "https://cdn.faire.com/fastly/7ffae9a896c3202d8d82620cfe6c4f74c03bd12ec7547301122c9a3933bb8f92.jpeg",
    "https://cdn.faire.com/fastly/7e06ad6be230311eaef1012a24fd7b981fe33321ae7a21498726d310dbf10ad8.jpeg",
    "https://cdn.faire.com/fastly/a8230c0d2c0ebe0312a73c3776d00a04aa13a06668a5116109a7e934b4715322.jpeg",
    "https://cdn.faire.com/fastly/ab4824b370063c7e58e8149346e8db19bf24ecc699bbcdefa5f7aa11d0160e27.jpeg",
    "https://cdn.faire.com/fastly/b9c2d7652cfe49510fe3632a188e7d22efe8f4ebde68f194b613e89ec24fa8a9.jpeg",
    "https://cdn.faire.com/fastly/c944b604ca3abe3c913f89f287bc185f559acb2b77adf9c4b8e63bdd20a13cd0.jpeg",
    "https://cdn.faire.com/fastly/077b4f2fb9b8bf87f98dbefb9ef4756c50ac12cc45e84eac4f19ad2e0599b6cf.jpeg",
    "https://cdn.faire.com/fastly/31e46a7290058573df7c0c364363d437b898d79e1bf61f184baa5afbe7371171.jpeg",
    "https://cdn.faire.com/fastly/02bc09469221d31ff164c3495b3064f23ab2b4b64afeb2edb663e5164dab91ee.jpeg",
    "https://cdn.faire.com/fastly/8db00eefac4a4c59c9b9aca92b871bbf2de259ccc90625d0b96620de8adf1fa2.jpeg",
    "https://cdn.faire.com/fastly/9cf3d8313d83a2cc4ac28922716dee5b43f2cac0e639556563b5e6a397e8b474.jpeg",
    "https://cdn.faire.com/fastly/03b45f561fd79c5abdbe0fd733e45503579b6eb0baf51a7fcd485b708949f354.jpeg",
    "https://cdn.faire.com/fastly/0bb23d6dc1ac5d58c63c1eb19050ef13c70e7460406112e346345e18dc0195e4.jpeg",
    "https://cdn.faire.com/fastly/580c6b24d4b6790bba8415a162330cdf2e40a8fd691249359a4a7897e6bd6d6a.jpeg",
    "https://cdn.faire.com/fastly/23bd99a2efeffc9f69b9d6dcae72bcc85fd8409d1bb0410b71657529f1685aa4.jpeg",
    "https://cdn.faire.com/fastly/0b21dcdc8acd87bb85c5d481d99bada8671b14edfb3a32927eda2ad7b409faf1.jpeg",
    "https://cdn.faire.com/fastly/a009305db07989daeff40f9eee09b6697b94cfdb3956e9a3af6efb247322abb4.jpeg",
    "https://cdn.faire.com/fastly/95aa63c7b5d774744c96473cb6181bad37388f3999157aa3ee8f2d153b0e601a.jpeg"
  ],
  priceDollars: 28.41,
  description: "SIZE & FIT :\n\nMODEL WEARS SIZE SMALL\nMODEL'S HEIGHT 5'9",
  tags: [],
  msrpDollars: 56.81,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:08:13.066Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
